function getDefaultWixappsModel() {
  return { appbuilder: { metadata: { appbuilder_metadata: { requestedPartNames: [] } } } }
}

function getWixCodeAppDefId(clientSpecMap) {
  for (const spec in clientSpecMap) {
    if (clientSpecMap[spec].type === 'siteextension') {
      return clientSpecMap[spec].appDefinitionId.toString()
    }
  }
}

function getPagesPlatformApplications(siteModel) {
  const wixCodeAppDefId = getWixCodeAppDefId(siteModel.rendererModel.clientSpecMap)
  if (!wixCodeAppDefId) {
    return
  }
  const pagesPlatformApplications = siteModel.rendererModel.pagesPlatformApplications
  const result = {}
  for (const pageId in pagesPlatformApplications) {
    if (pagesPlatformApplications.hasOwnProperty(pageId)) {
      pagesPlatformApplications[pageId].forEach(appId => {
        if (appId === wixCodeAppDefId) {
          appId = 'wixCode'
        }
        result[appId] = result[appId] || {}
        result[appId][pageId] = true
      })
    }
  }
  return result
}

export default function (window, sendErrorOrQueue) {
  return function convertSiteModel(rendererModel, publicModel) {
    function getPagesDataFromSiteAsJson(siteJson) {
      const initialPagesData = {
        masterPage: siteJson.masterPage
      }

      return siteJson.pages.reduce((accum, val) => {
        accum[val.structure.id] = val
        return accum
      }, initialPagesData)
    }

    const siteModel = {
      publicModel,
      urlFormatModel: rendererModel.urlFormatModel,
      routers: rendererModel.routers,
      serviceTopology: window.serviceTopology,
      santaBase: window.santaBase,
      configUrls: window.configUrls,
      rendererModel,
      componentGlobals: window.componentGlobals,
      serverAndClientRender: window.serverAndClientRender,
      adData: window.adData,
      mobileAdData: window.mobileAdData,
      googleAnalytics: window.googleAnalytics,
      googleRemarketing: window.googleRemarketing,
      facebookRemarketing: window.facebookRemarketing,
      yandexMetrika: window.yandexMetrika,
      wixData: window.wixData,
      wixapps: window.wixapps || getDefaultWixappsModel(),
      wixBiSession: window.wixBiSession,
      pagesData: window.pagesData,
      svgShapes: window.svgShapes,
      contactforms_metadata: {},
      renderFlags: {}
    }
    siteModel.siteHeader = { id: siteModel.rendererModel.siteId, userId: siteModel.rendererModel.userId } // required
    siteModel.siteId = siteModel.rendererModel.siteId // required
    siteModel.viewMode = siteModel.rendererModel.previewMode ? 'preview' : 'site' // required
    if (window.siteAsJson) {
      movePageDataToMaster(window.siteAsJson, sendErrorOrQueue)
      siteModel.pagesData = getPagesDataFromSiteAsJson(window.siteAsJson)
    }
    const pagesPlatformApplications = getPagesPlatformApplications(siteModel)
    if (pagesPlatformApplications) {
      siteModel.pagesPlatformApplications = pagesPlatformApplications
    }
    if (window.documentServicesModel) {
      siteModel.documentServicesModel = window.documentServicesModel
    }
    return siteModel
  }
}

function movePageDataToMaster(siteAsJson, sendErrorOrQueue) {
  const masterData = siteAsJson.masterPage.data.document_data

  function move(ref, to, from) {
    if (!get(from, ref)) {
      return
    }

    if (!get(to, ref)) {
      set(to, ref, get(from, ref))
    }
    remove(from, ref)
  }

  function get(parentData, ref) {
    return ref && parentData[ref.replace('#', '')]
  }

  function set(parentData, ref, dataToSet) {
    if (ref) {
      parentData[ref.replace('#', '')] = dataToSet
    }
  }

  function remove(parentData, ref) {
    if (ref) {
      delete parentData[ref.replace('#', '')]
    }
  }

  function moveMediaRef(masterPageDocumentData, pageData, mediaRef) {
        // Image or WixVideo
    const media = get(pageData, mediaRef)
    move(mediaRef, masterPageDocumentData, pageData)
        // Image
    move(media.posterImageRef, masterPageDocumentData, pageData)
  }

  siteAsJson.pages.forEach(page => {
    if (!page.structure) {
      return
    }

    const pageData = page.data.document_data
    const pageId = page.structure.id
    let desktopBg
    let mobileBg

        // Pages or AppPages
    const pageItem = get(pageData, pageId)
    move(pageId, masterData, pageData)

    if (pageItem && pageItem.pageBackgrounds && pageItem.pageBackgrounds.desktop.ref) {
            // BackgroundImage or BackgroundMedia
      desktopBg = get(pageData, pageItem.pageBackgrounds.desktop.ref)
      mobileBg = get(pageData, pageItem.pageBackgrounds.mobile.ref)
      move(pageItem.pageBackgrounds.desktop.ref, masterData, pageData)
      move(pageItem.pageBackgrounds.mobile.ref, masterData, pageData)

            // const wixBiSession = window.wixBiSession || {} TODO: Indeed unused?

            //BackgroundMedia
      if (desktopBg) {
        if (desktopBg.mediaRef) {
          moveMediaRef(masterData, pageData, desktopBg.mediaRef)
        }
                //Image
        move(desktopBg.imageOverlay, masterData, pageData)
      } else {
        sendErrorOrQueue({
          errorName: 'MISSING_DESKTOP_BACKGROUND_ITEM',
          errorCode: 112001,
          severity: 30
        }, pageItem.id)
      }

      if (mobileBg) {
        if (mobileBg.mediaRef) {
          moveMediaRef(masterData, pageData, mobileBg.mediaRef)
        }
                //Image
        move(mobileBg.imageOverlay, masterData, pageData)
      } else {
        sendErrorOrQueue({
          errorName: 'MISSING_MOBILE_BACKGROUND_ITEM',
          errorCode: 112002,
          severity: 30
        }, pageItem.id)
      }
    }
  })
}



// WEBPACK FOOTER //
// ./~/santa-main-r/src/main/lib/viewer/convertSiteModel.js